<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini" style="width: 100%;">
      <div class="formItemBox">
        <el-form-item label="流程名称:" prop="name">
                <el-input  placeholder="" v-model="searchFrom.name"></el-input>
              </el-form-item>
        <el-form-item label="适用仓库:" prop="organizationId">
          <el-select  v-model="searchFrom.organizationId"  placeholder="">
            <el-option v-for="val in warehouseList" :label="val.tenantName" :value="val.tenantCode" :key="val.tenantCode"></el-option>
          </el-select>
        </el-form-item>
       <el-form-item label="业务类型:" prop="formType">
          <el-select  v-model="searchFrom.formType"  placeholder="请选择">
            <el-option v-for="val in ywlx" :label="val.name" :value="val.id" :key="val.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间:" prop="createTime">
            <el-date-picker
              v-model="searchFrom.createTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
        </el-form-item>
      </div>
       <div class="searchBtnBox">
         <el-form-item btnCode="00FP001B001"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item >
          <el-form-item btnCode="00FP001B002"  v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
           <el-form-item btnCode="00FP001B003"  v-if="btnFlg[2]">
            <el-button type="primary"  @click="addFn">新建流程</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" >
      <el-table :data="tableList"  ref="table" v-loading="loading" :span-method="objectSpanMethod"   bordersize="mini"
       style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" property="caozuo" width="120">
            <template slot-scope="scope">
              <div>
                <el-button type="text" btnCode="00FP001B004"  v-if="btnFlg[3]" v-show="scope.row.isUse==1?false:true" @click="changeIsUse(1,scope.row.flowId)" size="mini">启用</el-button>
                <el-button type="text" btnCode="00FP001B004"  v-if="btnFlg[3]" v-show="scope.row.isUse==1?true:false" @click="changeIsUse(2,scope.row.flowId)" size="mini">停用</el-button>
                <el-button type="text" btnCode="00FP001B005"  v-if="btnFlg[4]" v-show="scope.row.isUse==1?false:true" @click="editFn(scope.row.flowId)" size="mini">编辑</el-button>
                <el-button type="text" btnCode="00FP001B006"  v-if="btnFlg[5]" v-show="scope.row.isUse==1?false:true" @click="delFn(scope.row.flowId)" size="mini">删除</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column property="name" width="120" :formatter="emptyFn" label="流程名称"></el-table-column>
        <el-table-column property="orderSource" width="120" label="启用状态">
          <template scope="scope">
            <span>{{[ "启用", "停用"][scope.row.isUse-1]}}</span>
          </template>
        </el-table-column>
        <el-table-column property="formType" width="120" label="业务类型">
          <template scope="scope">
            <span>{{[ "实捆提货", "实捆转货",'发布货源','维修','虚捆提货','虚捆转货'][scope.row.formType-1]}}</span>
          </template>
        </el-table-column>
        <el-table-column property="sortNum" width="120" :formatter="emptyFn" label="审批次序"></el-table-column>
        <el-table-column property="operationUserNames" width="120" :formatter="emptyFn" label="审批人"></el-table-column>
         <el-table-column label="审批条件"  width="180">
              <template slot-scope="scope">
                <div>
                <span v-if="scope.row.minWeight!=-1">重量&nbsp;≥&nbsp;{{scope.row.minWeight}}吨</span><br>
                <span v-if="scope.row.minNum!=-1">件数&nbsp;≥&nbsp;{{scope.row.minNum}}件</span>
                </div>
              </template>
          </el-table-column>
         <el-table-column prop="organizationName" min-width="200" :formatter="emptyFn" label="适用仓库"></el-table-column>
        <el-table-column prop="createUserName" width="160" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { warehouseList, flowListNew, isUse, cFlowDel } from '@/api/common-signature'
import { emptyFn, dateTimeFormat } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500',
      searchFrom: {
      },
      loading: false,
      ywlx: [
        { name: '实捆提货', id: 1 },
        { name: '实捆转货', id: 2 },
        // { name: '发布货源', id: 3 }
        { name: '维修', id: 4 },
        { name: '虚捆提货', id: 5 },
        { name: '虚捆转货', id: 6 }
      ],
      tableList: [],
      warehouseList: [],
      rowArr: [],
      btnFlg: [],
      btnIdArr: ['00FP001B001', '00FP001B002', '00FP001B003',
        '00FP001B004', '00FP001B005', '00FP001B006']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/examine')
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.warehouseList = [{
        tenantName: localStorage.getItem('createTenantName'),
        tenantCode: localStorage.getItem('createTenantCode')
      }]
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].tenantCode)
    } else {
      warehouseList().then(res => {
        this.warehouseList = res
      })
    }
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 158) + 'px'
  },
  methods: {
    // 更改状态
    changeIsUse (n, id) {
      isUse({ id: id, isUse: n }).then(res => {
        this.getList(this.searchFrom)
        this.$message({
          message: '操作成功',
          type: 'success'
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {

          }
        })
      })
    },
    // 合并单元格
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'caozuo' || column.property == 'name' || column.property == 'orderSource' || column.property == 'formType' ||
      column.property == 'organizationName' || column.property == 'createUserName' || column.property == 'createTime') {
        const _row = this.rowArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.tableList = []
      this.rowArr = []
      flowListNew(searchFrom).then(res => {
        res.forEach((item, index) => {
          item.cFlowNodeList.forEach((itemA, i) => {
            this.tableList.push(itemA)
            if (i == 0) {
              this.rowArr.push(item.cFlowNodeList.length)
            } else {
              this.rowArr.push(0)
            }
          })
        })
        this.loading = false
      })
    },

    // 新加
    addFn () {
      this.$router.push({ name: 'addExamine' })
    },
    // 修改
    editFn (id) {
      this.$router.push({ name: 'editExamine', query: { id: id } })
    },

    // 删除
    delFn (id) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cFlowDel({ id: id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
      }
      if (localStorage.getItem('isCutCrm3') == 1) {
        this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].tenantCode)
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>

.table{
  margin-top: 20px;
}
.liucheng{
   margin-bottom: 12px;
    h4{
      margin: 0;
      background: #0c46a2;
      display: flex;
      justify-content: space-between;
      padding: 8px 16px;
      font-size: 15px;
      color: #fff;
      align-items: center;
    }
    /deep/.el-button{
      background-color: #169BD5;
      color: #fff;
      border-color: #169BD5;
    }
    /deep/.el-button:hover{
      background-color: #169BD5;
      color: #fff;
      border-color: #169BD5;
    }
}
.description{
  color: #333;
}
.zhuangt{
  margin-right: 10px;
  font-size: 14px;
  font-weight: normal;
}
/deep/.el-switch__label--left{
  color: #fff!important;
}
 .nodata{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .inpBox .el-date-editor{
      width: 350px!important;
}
.searchBtnBox{
  margin: 0;
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }

</style>
